import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Users, Timer, ShieldCheck } from "lucide-react";

const Urgency = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      ref={ref}
      className="relative overflow-hidden border-y border-black/10 bg-[#0a0a0a] py-16"
      data-testid="urgency-strip"
    >
      <div className="relative z-10 mx-auto flex max-w-6xl flex-col items-center justify-between gap-10 px-5 sm:px-8 lg:flex-row">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="flex items-center gap-5"
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10">
            <Users className="h-7 w-7 text-white" />
          </span>
          <div>
            <p className="font-display text-4xl font-extrabold text-white" data-testid="joined-counter">
              Limited
            </p>
            <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-slate-400">
              seats per room, so quality stays high
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="flex max-w-xs items-center gap-3 text-center font-mono2 text-xs uppercase tracking-widest text-slate-300"
        >
          <ShieldCheck className="h-4 w-4 shrink-0" />
          When the room fills, new entries wait for the next window
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="flex items-center gap-4 rounded-2xl border border-white/15 bg-white/5 px-6 py-4"
          data-testid="countdown-timer"
        >
          <Timer className="h-6 w-6 text-white" />
          <div>
            <p className="font-display text-3xl font-extrabold tabular-nums text-white">05:00</p>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-400">
              single-use invite link validity
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Urgency;
